// material-ui
import { Theme, styled } from '@mui/material/styles';
import LinearProgress from '@mui/material/LinearProgress';

interface Props{
  theme:Theme
}
// loader style
const LoaderWrapper = styled('div')(({ theme }:Props) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 2001,
  width: '100%',
  '& > * + *': {
    marginTop: theme.spacing(2)
  }
}));

// ==============================|| Loader ||============================== //

const Loader = () => (
  <LoaderWrapper>
    <LinearProgress color="primary" />
  </LoaderWrapper>
);

export default Loader;
